
import React, { useEffect } from "react";
import DashboardLayout from "@/components/dashboard/DashboardLayout";
import { DashboardHeader } from "@/components/dashboard/DashboardHeader";
import { DashboardStats } from "@/components/dashboard/DashboardStats";
import { PromptsList } from "@/components/dashboard/PromptsList";
import { NewsList } from "@/components/dashboard/NewsList";
import { UpcomingAppointments } from "@/components/dashboard/UpcomingAppointments";
import { useDashboardData } from "@/hooks/useDashboardData";
import { useDashboardStats } from "@/hooks/useDashboardStats";
import { useAuth } from "@/contexts/AuthContext";
import { toast } from "@/components/ui/use-toast";
import { supabase } from "@/integrations/supabase/client";

const Dashboard = () => {
  const { prompts, novidades, isLoading, refetch } = useDashboardData();
  const { stats, isLoading: isStatsLoading } = useDashboardStats();
  const { user, session, signOut, forceLogout } = useAuth();

  // Verify session on dashboard load
  useEffect(() => {
    const verifySessionStatus = async () => {
      try {
        if (!user) return;
        
        const { data, error } = await supabase.auth.getSession();
        
        if (error || !data.session) {
          console.warn("Dashboard detected invalid session:", error || "No session found");
          toast({
            title: "Sessão inválida",
            description: "Sua sessão expirou. Por favor, faça login novamente.",
            variant: "destructive",
          });
          
          // Force logout after small delay
          setTimeout(() => forceLogout(), 100);
        }
      } catch (err) {
        console.error("Error verifying session on dashboard:", err);
      }
    };
    
    verifySessionStatus();
  }, [user, forceLogout]);

  const handleLogout = async () => {
    try {
      await signOut();
    } catch (error) {
      console.error("Error during logout:", error);
      toast({
        title: "Erro ao deslogar",
        description: "Forçando logout local. Por favor, faça login novamente.",
        variant: "destructive",
      });
      forceLogout();
    }
  };

  return (
    <DashboardLayout title="Dashboard" isLoading={isLoading}>
      <div className="space-y-4">
        <DashboardHeader />

        <div className="grid gap-4">
        

          {/* Prompts e Novidades */}
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            <PromptsList prompts={prompts} isLoading={isLoading} />
            <NewsList novidades={novidades} isLoading={isLoading} />
          </div>

          {/* Próximos Agendamentos */}
          <div>
            <UpcomingAppointments 
              appointments={stats?.upcomingAppointments || []} 
              isLoading={isStatsLoading} 
            />
          </div>

            {/* Estatísticas */}
          <div>
            <DashboardStats />
          </div>
        </div>
      </div>
    </DashboardLayout>

  );
};

export default Dashboard;
